/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@-webkit-keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}[_nghost-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:100%;width:100%;-ms-flex-pack:center;justify-content:center}[_nghost-%COMP%]   .loader[_ngcontent-%COMP%]{border-radius:50%;width:14px;height:14px;border:.25rem solid #969696;border-top-color:#fff;-webkit-animation:1s linear infinite spin;animation:1s linear infinite spin}"];
export { styles as styles };
